import React, { useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { NavLink, useLocation } from 'react-router-dom';

import { RootState } from '../../lib/store';
import { isUserVerifiedStatus } from '../../lib/store/selectors';
import { isMyPortalTrade } from '../../lib/util/auth/helpers';

import config from '../../config';
import { UI_ROUTES } from '../../util/routes';

import { MENU_LIST } from './Downbar.constants';
import { DownBarIdType, DownBarItem } from './Downbar.types';

import styles from './Downbar.module.scss';

type Props = {} & ReduxProps;

const Downbar = (props: Props) => {
  const { individual, hasDeposit } = props;
  const location = useLocation();
  const isUserVerified = isUserVerifiedStatus(individual);
  const [destination, setDestination] = useState<string>(location.pathname);

  let FILTERED_MENU_LIST: DownBarItem[] = [];
  if (isMyPortalTrade()) {
    FILTERED_MENU_LIST = MENU_LIST.filter(item => item.id !== DownBarIdType.MyProfile);
  } else {
    FILTERED_MENU_LIST = MENU_LIST.filter(item => item.id !== DownBarIdType.FundPortal);
  }

  FILTERED_MENU_LIST.find(
    item => item.id === DownBarIdType.Funds,
  )!.path = ((!isUserVerified || hasDeposit) || isMyPortalTrade())
    ? UI_ROUTES.funds
    : UI_ROUTES.funds + UI_ROUTES.makeYourFirstDeposit;

  const options = () => (
    FILTERED_MENU_LIST.map((item: DownBarItem) => {
      if (item.id === DownBarIdType.FundPortal) {
        return (
          <a
            href={config.links.fundPortalUrl}
            className={location.pathname === item.path ? styles.activeButton : styles.button}
            key={item.id}
          >
            <div
              id={item.id}
              key={item.id}
            >
              <div className={styles.image}>{item.img}</div>
              <div className={location.pathname === item.path ? styles.activeLabel : styles.label}>{item.label}</div>
            </div>
          </a>
        );
      }

      return (
        <button
          type="button"
          className={location.pathname === item.path ? styles.activeButton : styles.button}
          key={item.id}
        >
          <NavLink
            id={item.id}
            key={item.id}
            to={{
              pathname: item.path,
              state: {
                isClickedBtnSidebar: true,
              },
            }}
            style={{ textDecoration: 'none' }}
            onClick={() => {
              setDestination(item.path);
            }}
          >
            <div className={styles.image}>{item.img}</div>
            <div className={location.pathname === item.path ? styles.activeLabel : styles.label}>{item.label}</div>
          </NavLink>
        </button>
      );
    }));

  return (
    <div className={styles.Wrapper}>
      <div className={styles.buttonsWrapper}>
        {options()}
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  individual: state.crm.individualExtendedInfo,
  hasDeposit: state.payment.hasDeposit,
});
const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(Downbar);
